// extracted by mini-css-extract-plugin
module.exports = {"Border1":"Border_Border1__36wVE","Border2":"Border_Border2__129E1"};